import CryptoJS from 'crypto-js';

function DecryptData(data) {
  const { REACT_APP_ENCRYPT_KEY } = process.env;
  const apiKey = REACT_APP_ENCRYPT_KEY;

  if (!apiKey) {
    throw new Error('Encryption key is missing');
  }

  function isBase64(str) {
    // A regex to check if a string is a valid Base64-encoded string
    const base64Regex = /^(?:[A-Z0-9+/]{4})*(?:[A-Z0-9+/]{2}==|[A-Z0-9+/]{3}=)?$/i;
    return base64Regex.test(str);
  }

  // console.log(window.atob(data), 'data');
  let encrypted = {};
  if (isBase64(data)) {
    try {
      // Decode the base64 encoded string using atob
      encrypted = JSON.parse(window.atob(data));
      // console.log('Laravel encryption result', encrypted);
    } catch (e) {
      throw new Error(`Failed to decode base64 string: ${e.message}`);
    }
  } else {
    console.error('The string to be decoded is not correctly encoded.');
  }

  // console.log('Laravel encryption result', encrypted);

  // IV and value are base64 encoded, so parse them
  if (encrypted?.iv) {
    const iv = CryptoJS.enc.Base64.parse(encrypted.iv);
    const { value } = encrypted;

    // Key is base64 encoded, so parse it
    const key = CryptoJS.enc.Base64.parse(apiKey);

    // Decrypt the value using the key and IV
    let decrypted = CryptoJS.AES.decrypt(value, key, { iv });

    // Convert the decrypted data from a word array to a UTF-8 string
    decrypted = decrypted.toString(CryptoJS.enc.Utf8);

    // Parse the decrypted string as JSON
    try {
      return JSON.parse(decrypted);
    } catch (e) {
      throw new Error(`Failed to parse decrypted data as JSON: ${e.message}`);
    }
  }
}

export default DecryptData;

// import CryptoJS from 'crypto-js';
// // import PropTypes from 'prop-types';

// function DecryptData(data) {
//   const { REACT_APP_ENCRYPT_KEY } = process.env;
//   const apiKey = REACT_APP_ENCRYPT_KEY;

//   console.log(data, 'data');
//   // Laravel creates a JSON to store iv, value and a mac and base64 encodes it.
//   // So let's base64 decode the string to get them.
//   let encrypted = atob(data);
//   console.log(encrypted, 'encrypted');
//   encrypted = JSON.parse(encrypted);

//   console.log('Laravel encryption result', encrypted);
//   // IV is base64 encoded in Laravel, expected as word array in cryptojs
//   const iv = CryptoJS.enc.Base64.parse(encrypted.iv);
//   // Value (chipher text) is also base64 encoded in Laravel, same in cryptojs
//   const { value } = encrypted;

//   // Key is base64 encoded in Laravel, word array expected in cryptojs
//   const key = CryptoJS.enc.Base64.parse(apiKey);
//   // Decrypt the value, providing the IV.
//   let decrypted = CryptoJS.AES.decrypt(value, key, {
//     iv
//   });
//   // CryptoJS returns a word array which can be
//   // converted to string like this
//   decrypted = decrypted.toString(CryptoJS.enc.Utf8);
//   return JSON.parse(decrypted);
// }

// export default DecryptData;
